import { Component, Input, OnInit } from '@angular/core';
import { DefaultLanguage } from '@shared/constants/constants';
import { ContentContextType } from '@shared/enums/ContentContextType';
import { ContentMediaType } from '@shared/enums/ContentMediaType';
import { IAdvancedTemplateModel } from '@shared/services/api/dashboard/advanced-templates-service/advanced-templates.model';
import { StyleService } from '@shared/services/style/style.service';
import { BehaviorSubject } from 'rxjs';

@Component({
    selector: 'app-advanced-template-preview',
    templateUrl: './advanced-template-preview.component.html',
    styleUrls: ['./advanced-template-preview.component.scss'],
})
export class AdvancedTemplatePreviewComponent implements OnInit {

    public ContentContextType = ContentContextType;
    public ContentMediaType = ContentMediaType;

    public showHeader = false;
    public showBanner = false;
    public showContent = false;
    public showFooter = false;

    public heightHeader = 0;
    public heightBanner = 0;
    public heightContent = 60;
    public heightFooter = 0;

    constructor(
        public styleService: StyleService
    ) { }

    @Input()
    get model(): IAdvancedTemplateModel { return this.model$.value; }
    set model(value: IAdvancedTemplateModel) { this.model$.next(value); }
    public model$: BehaviorSubject<IAdvancedTemplateModel> = new BehaviorSubject<IAdvancedTemplateModel>(undefined);

    @Input()
    get language(): string { return this.language$.value; }
    set language(value: string) { this.language$.next(value); }
    public language$: BehaviorSubject<string> = new BehaviorSubject<string>(DefaultLanguage);

    @Input()
    get contentContextType(): ContentContextType { return this.contentContextType$.value; }
    set contentContextType(value: ContentContextType) { this.contentContextType$.next(value); }
    public contentContextType$: BehaviorSubject<ContentContextType> = new BehaviorSubject<ContentContextType>(ContentContextType.Email);

    @Input()
    get mediaTypePage(): ContentMediaType { return this.mediaTypePage$.value; }
    set mediaTypePage(value: ContentMediaType) { this.mediaTypePage$.next(value); }
    public mediaTypePage$: BehaviorSubject<ContentMediaType> = new BehaviorSubject<ContentMediaType>(undefined);

    @Input()
    get mediaTypeEmail(): ContentMediaType { return this.mediaTypeEmail$.value; }
    set mediaTypeEmail(value: ContentMediaType) { this.mediaTypeEmail$.next(value); }
    public mediaTypeEmail$: BehaviorSubject<ContentMediaType> = new BehaviorSubject<ContentMediaType>(undefined);

    public ngOnInit(): void {
        this.mediaTypeEmail = this.model?.bannerSetting?.contents?.find(x => x.contentContextType === ContentContextType.Email)?.contentMediaType;

        // Hide blocks where content is empty
        // Depending on if there is content, recalculate the height depending on the blocks that need to be shown if there is content
        if (this.model.headerSetting.showContent && (this.model.headerSetting.contents?.find(x => x.languageId === this.language)?.url) || this.model.headerSetting.showText) {
            this.showHeader = true;
            this.heightHeader = 10;
        } else {
            this.heightContent += 10;
        }
        if (this.contentContextType === ContentContextType.Email &&
            (this.model.bannerSetting.contents?.find(x => x.languageId === this.language && x.contentContextType === this.contentContextType && x.contentMediaType === this.mediaTypeEmail)?.url)) {
            this.showBanner = true;
            this.heightBanner = 15;
        } else {
            this.heightContent += 15;
        }
        if (this.model.footers?.length > 0) {
            this.showFooter = true;
            this.heightFooter = 15;
        } else {
            this.heightContent += 10;
        }
    }

}
